<template>

    <div class="widget-content-text">

        <dmb-widget-styled-text v-if="widget.settings" :style="widget.settings.textStyle">{{ widget.settings.content }}</dmb-widget-styled-text>

    </div>

</template>

<script>

import { Vue, Options } from 'vue-class-component'

import WidgetStyledText from "../WidgetStyledText.vue";

export default Options({
    name: 'dmb-widget-content-text',
    components: {
        [WidgetStyledText.name]: WidgetStyledText
    },
    props: {
        widget: Object,
        freeze: Boolean
    }
})(
    class WidgetContentText extends Vue {

    }
)

</script>
<style src="../../../scss/component/widget/WidgetContentText.scss" lang="scss"></style>
